/*
 * Copyright 2022. NXGN Management, LLC. All Rights Reserved.
 */

import { Pipe, PipeTransform } from "@angular/core";
import { UserRoles } from "../models/roles";

@Pipe({
  name: "roleLabel"
})
export class RoleLabelPipe implements PipeTransform {
  transform(value: string): string {
    return UserRoles[value as keyof typeof UserRoles];
  }
}
